import { DAYS_IN_4_WEEKS } from '@/constants/global';
import { LUXON_DATE_FORMAT_LONG } from '@/constants/dateTimeFormats';
import { DateTime } from 'luxon';

export function addItem(event, itemId, list, filterList) {
    const items = itemId === 'all' ? list.map(({ id }) => id) : [itemId];
    items.forEach(id => toggleItem(event, id, filterList));
}

export function toggleItem(selectItem, itemId, filterList) {
    const index = filterList.indexOf(itemId);
    selectItem && index === -1 && filterList.push(itemId);
    !selectItem && index !== -1 && filterList.splice(index, 1);
}

const squads = localStorage.getItem('ludum-filter-squads');
const tags = localStorage.getItem('ludum-filter-tags');

export const reportsGlobal = {
    namespaced: true,

    state: {
        filter: {
            squads: squads ? JSON.parse(squads) : [],
            startDate:
                localStorage.getItem('ludum-filter-start-date') ||
                DateTime.now().minus({ days: DAYS_IN_4_WEEKS }).toISO(),
            endDate: localStorage.getItem('ludum-filter-end-date') || DateTime.now().toISO(),
            tags: tags ? JSON.parse(tags) : []
        }
    },

    getters: {
        filter(state) {
            return {
                startDate: DateTime.fromISO(state.filter.startDate).toISODate(),
                endDate: DateTime.fromISO(state.filter.endDate).toISODate(),
                squads: state.filter.squads,
                tags: state.filter.tags
            };
        },

        globalFilterRange({ filter }) {
            const startDate = DateTime.fromISO(filter.startDate).toFormat(LUXON_DATE_FORMAT_LONG);
            const endDate = DateTime.fromISO(filter.endDate).toFormat(LUXON_DATE_FORMAT_LONG);
            return `${startDate}-${endDate}`;
        }
    },

    mutations: {
        setStartDate(state, startDate) {
            state.filter.startDate = startDate;
            localStorage.setItem('ludum-filter-start-date', startDate);
        },

        setEndDate(state, endDate) {
            state.filter.endDate = endDate;
            localStorage.setItem('ludum-filter-end-date', endDate);
        },

        setSquads(state, { event, id, squads }) {
            addItem(event, id, squads, state.filter.squads);
            localStorage.setItem('ludum-filter-squads', JSON.stringify(state.filter.squads));
        },

        setAllSquads(state, squads) {
            state.filter.squads = squads;
            localStorage.setItem('ludum-filter-squads', JSON.stringify(state.filter.squads));
        },

        removeSquads(state) {
            state.filter.squads = [];
            localStorage.removeItem('ludum-filter-squads');
        },

        setTags(state, { event, id, tags }) {
            state.filter.tags = id;
            localStorage.setItem('ludum-filter-tags', JSON.stringify(id));
        },

        setAllSTags(state, tags) {
            state.filter.tags = tags;
            localStorage.setItem('ludum-filter-tags', JSON.stringify(state.filter.tags));
        },

        removeTags(state) {
            state.filter.tags = [];
            localStorage.removeItem('ludum-filter-tags');
        }
    }
};

export default reportsGlobal;
